// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"0d006a6a","353":"655a7ec9"}[chunkId] + ".js";
};